import { httpClient } from "../api/client";

export async function createFormatTemplate(formatId: string, data: any) {
  const response = await httpClient.post("/create-format-template", data, {
    params: { formatId },
  });

  return response.data;
}